
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/layouts/Icon.vue';

export type SubsEditMode = 'EditTargetPerson' | 'EditCouponApply';

export type RelationshipOption = {
  code: string;
  degree: string;
  label: string;
};

export type AgeTypeOption = {
  name: string;
  value: string;
};

export type TargetPerson = {
  couponApplicableNo: number;
  lastName: string;
  firstName: string;
  relationship: string;
  degreeCount: string;
  age: number | '';
  ageType: string;
};

export type TargetPersonMaster = {
  relationshipOptions: RelationshipOption[];
  ageTypeOptions: AgeTypeOption[];
};

@Component({
  components: {
    Icon,
  },
})
export default class TargetPersonFormComponent extends Vue {
  @Prop({ type: Object, required: true })
  targetPerson!: TargetPerson;

  @Prop({ type: Object, required: true })
  targetPersonMaster!: TargetPersonMaster;

  @Prop({ type: String, required: true })
  editMode!: SubsEditMode;

  get disabledInput(): boolean {
    return this.editMode !== 'EditTargetPerson';
  }

  get disabledAge(): boolean {
    return this.disabledInput || this.targetPerson.ageType !== '子供';
  }

  clickStepDown(): void {
    // validate.
    if (this.disabledInput) return;

    if (!this.targetPerson.age) {
      this.targetPerson.age = 0;
    } else if (this.targetPerson.age <= 0) {
      // do nothing.
    } else {
      this.targetPerson.age = Number(this.targetPerson.age) - 1;
    }
  }

  clickStepUp(): void {
    // validate.
    if (this.disabledInput) return;

    if (!this.targetPerson.age) {
      this.targetPerson.age = 1;
    } else {
      const nextVal = Number(this.targetPerson.age) + 1;
      this.targetPerson.age = nextVal > 12 ? 12 : nextVal;
    }
  }

  clickDelete(): void {
    // validate.
    if (this.disabledInput) return;

    this.$emit('delete', this.targetPerson);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  changeRelationship(event: any): void {
    const relationshipOption = this.targetPersonMaster.relationshipOptions.find((option) => option.code === event.target.value);
    if (relationshipOption) {
      this.targetPerson.degreeCount = relationshipOption.degree;
      this.$emit('checkDegreeCount', this.targetPerson.couponApplicableNo);
    }
  }

  changeAgeType(): void {
    if (this.targetPerson.ageType !== '子供') {
      this.targetPerson.age = '';
    }
  }
}
